import React, { useEffect, useState } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import { parse } from "tldts";
import "../css/TeamsPage.css";
import "../css/Navbar.css";
import Navbar from "./Navbarlanding";
import Footer from "./Footerlanding";

const TeamsPage = () => {
  const [teams, setTeams] = useState([]);
  const [loading, setLoading] = useState(true);

  const [menuOpen, setMenuOpen] = useState(false);
  const [loginDropdownOpen, setLoginDropdownOpen] = useState(false);
  const [applyNowOpen, setApplyNowOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  const [company, setCompany] = useState({
    name: "Your Company",
    logo: "",
    favicon: "",
    domain: "",
    subdomain: "",
    superAdminId: "",
  });

  const getDomainInfo = () => {
    const hostname = window.location.hostname;
    const parsed = parse(hostname);

    return {
      domain: parsed.domainWithoutSuffix || "",
      subdomain: parsed.subdomain || "",
    };
  };

  useEffect(() => {
  const loadCompany = async () => {
    try {
      const { domain } = getDomainInfo();

      const response = await axios.get(
        "https://payyug.in/api/get-company",
        {
          params: { domain },
        }
      );

      const data = response.data;

      if (data) {
        setCompany(data);
      }
    } catch (error) {
      console.log(error);
    }
  };

  loadCompany();
}, []);

  useEffect(() => {
    if (company.superAdminId) {
      fetchTeams(company.superAdminId);
    }
  }, [company.superAdminId]);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 40);
    };

    window.addEventListener("scroll", handleScroll);

    return () => window.removeEventListener("scroll", handleScroll);
  }, []);


  const fetchTeams = async (superAdminId) => {
    try {
      setLoading(true);

      const response = await axios.get(
        `https://payyug.in/api/get-all-team?superAdminId=${superAdminId}`
      );

      console.log(response.data);

      if (response.data.success) {
        setTeams(response.data.teamMembers || []);
      }
    } catch (error) {
      console.error("Error fetching teams:", error);
    } finally {
      setLoading(false);
    }
  };

  const getImageUrl = (photo) => {
    if (!photo) {
      return "https://cdn-icons-png.flaticon.com/512/149/149071.png";
    }

    return `https://payyug.in/${photo}`;
  };

  const getLogoUrl = (path) => {
    if (!path) return "";

    const cleanPath = path.startsWith("images/")
      ? path.slice(7)
      : path;

    return `https://payyug.in/${cleanPath}`;
  };

  const handleLinkClick = () => {
    if (window.innerWidth <= 960) {
      setMenuOpen(false);
      setLoginDropdownOpen(false);
      setApplyNowOpen(false);
    }
  };

  return (
    <div className="teams-page">

      {/* HEADER */}

     <Navbar/>

      {/* HERO */}

      <section className="teams-hero">

        <div className="hero-pattern"></div>

        <div className="teams-overlay">

          <h1>
            Meet Our <span>Leadership</span> Team
          </h1>

          <p>
            Experienced professionals driving trust,
            innovation and customer success.
          </p>

          <div className="hero-divider">
            <span></span>
            <i className="fas fa-diamond"></i>
            <span></span>
          </div>

        </div>

      </section>

      {/* TEAM SECTION */}

      <section className="teams-section">

        <div className="teams-container">

          {loading ? (
            <div className="loader-wrapper">
              <div className="loader"></div>
              <p>Loading Team Members...</p>
            </div>
          ) : teams.length === 0 ? (
            <div className="empty-state">
              <h2>No Team Members Found</h2>
            </div>
          ) : (
          <div className="leadership-grid">
            {teams.map((member) => (
              <div className="leadership-card" key={member.id}>

            <div className="leadership-top">

              <div className="leadership-image-box">
                <img
                  src={getImageUrl(member.photo)}
                  alt={member.name}
                  className="leadership-image"
                />
              </div>

              <div className="leadership-content">

                <span className="leadership-badge">
                  {member.designation}
                </span>

                <h2>{member.name}</h2>

                <div className="gold-line"></div>

                {/* <p className="leadership-desc">
                  Dedicated professional committed to customer satisfaction and business excellence.
                </p> */}

                <div className="leadership-socials">

                  {member.linkedin && (
                    <a
                      href={member.linkedin.startsWith("http")
                        ? member.linkedin
                        : `https://${member.linkedin}`}
                      target="_blank"
                      rel="noreferrer"
                    >
                      <i className="fab fa-linkedin-in"></i>
                    </a>
                  )}

                  {member.instagram && (
                    <a
                      href={member.instagram.startsWith("http")
                        ? member.instagram
                        : `https://${member.instagram}`}
                      target="_blank"
                      rel="noreferrer"
                    >
                      <i className="fab fa-instagram"></i>
                    </a>
                  )}

                  {member.facebook && (
                    <a
                      href={member.facebook.startsWith("http")
                        ? member.facebook
                        : `https://${member.facebook}`}
                      target="_blank"
                      rel="noreferrer"
                    >
                      <i className="fab fa-facebook-f"></i>
                    </a>
                  )}

                  {member.twitter && (
                    <a
                      href={member.twitter.startsWith("http")
                        ? member.twitter
                        : `https://${member.twitter}`}
                      target="_blank"
                      rel="noreferrer"
                    >
                      <i className="fab fa-x-twitter"></i>
                    </a>
                  )}

                </div>

              </div>

            </div>

            {/* <div className="leadership-bottom">

              <div className="feature">
                <i className="fas fa-users"></i>
                <span>Customer First</span>
              </div>

              <div className="feature">
                <i className="fas fa-chart-line"></i>
                <span>Growth Focus</span>
              </div>

              <div className="feature">
                <i className="fas fa-shield-alt"></i>
                <span>Trusted Team</span>
              </div>

            </div> */}

          </div>
            ))}
          </div>
          )}
        </div>
      </section>

      {/* FOOTER */}

      <Footer/>
    </div>
  );
};

export default TeamsPage;